import React from 'react'
import { Wrapper } from './atoms'

interface Props {
  fontSize?: number
  fontSizeMb?: number
  color?: string
  email: string
}

export const TooltipEmail = ({ fontSize = 16, fontSizeMb = 20, color = '#fff', email }: Props) => {
  return (
    <Wrapper $fontSize={fontSize} $fontSizeMb={fontSizeMb} $color={color}>
      <svg width='20' height='18' viewBox='0 0 20 18' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M16.2963 -0.000244141H3.7037C1.66667 -0.000244141 0 1.66642 0 3.70346V13.3331C0 15.3701 1.66667 17.0368 3.7037 17.0368H16.2963C18.3333 17.0368 20 15.3701 20 13.3331V3.70346C20 1.66642 18.3333 -0.000244141 16.2963 -0.000244141ZM3.7037 1.48124H16.2963C17.1111 1.48124 17.8148 1.92568 18.1852 2.55531L10.9259 8.4442C10.3704 8.88864 9.59259 8.88864 9.07407 8.4442L1.81481 2.55531C2.18518 1.92568 2.88889 1.48124 3.7037 1.48124ZM16.2963 15.5553H3.7037C2.48148 15.5553 1.48148 14.5553 1.48148 13.3331V4.22198L8.14815 9.62938C8.7037 10.0738 9.33333 10.2961 10 10.2961C10.6667 10.2961 11.3333 10.0738 11.8519 9.62938L18.5185 4.22198V13.3331C18.5185 14.5553 17.5185 15.5553 16.2963 15.5553Z'
          fill='white'
        />
      </svg>
      <span>E-mail: {email}</span>
    </Wrapper>
  )
}
